module.exports = __webpack_public_path__ + "img/big-box.dfa94309.jpg";